<template>
  <modal ref="modal">
    <div class="ms-3 mt-3 row col">
      {{ firstDescriptionText }}
    </div>
    <div class="ms-3 row col">
      {{ secondDescriptionText }}
    </div>
    <div class="row mt-3">
      <label class="col-2">
        <span v-if="required" class="badge rounded-0 bg-danger ms-3">必須</span>
      </label>
      <textarea rows="3" class="col-9 me-2" v-model="inputText" />
      <p class="text-danger ms-3">{{ errorText }}</p>
    </div>
    <modal-footer>
      <update-button @click="doUpdate" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalFooter from "@/views/atoms/ModalFooter";
import UpdateButton from '@/views/molecules/buttons/UpdateButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';

export default {
  name: "EditConfirmModalWithInputArea",
  components: {
    Modal,
    ModalFooter,
    UpdateButton,
    CancelButton,
  },
  data(){
    return {
      inputText: "",
      errorText: "",
    }
  },
  props: {
    firstDescriptionText: {
      type: String,
      default: null,
    },
    secondDescriptionText: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    },
    inputTextLabel: {
      type: String,
      required: true
    },
    textMaxLength: {
      type: Number,
      default: 5000
    },
    defaultValue: {
      type: String,
      default: null,
    }
  },
  emits: ['beforeUpdate', 'update'],
  methods: {
    show() {
      this.inputText = this.defaultValue;
      this.errorText = "";
      this.$refs.modal.show();
    },
    doUpdate() {
      if (this.required && this.inputText.length === 0) {
        this.errorText = this.inputTextLabel + "の入力は必須です。";
        return;
      }
      if (this.inputText.length > this.textMaxLength) {
        this.errorText = this.inputTextLabel + "は、" + this.textMaxLength + "文字以下で指定してください。";
        return;
      }
      this.$emit('beforeUpdate', this.inputText);
      this.$emit('update');
      this.$refs.modal.hide();
    },
  },
}
</script>
